import { isMultilingualVoice } from '@/hooks/useFilteredVoices';
import { useUpdateAgent } from '@/pages/agents/api';
import { AGENT_DEFAULT_NAME } from '@/pages/agents/constants';
import { useAgentEditorStore } from '@/state/root';
import { AgentCreateTabType, AgentUpdateDTO, IVoice } from '@d-id/types';
import { RawAgentUpdates, RawUpdatePayload } from '../types';

export const getAgentLanguage = (ttsSelectedVoice: IVoice | null, ttsSelectedLanguage: string | null) => {
    const isVoiceMultilingual = ttsSelectedVoice ? isMultilingualVoice(ttsSelectedVoice) : false;
    const isLanguageMultilingual = ttsSelectedLanguage?.toLowerCase() === 'multilingual';
    const useLanguageFromLanguageSelect = isVoiceMultilingual && !isLanguageMultilingual;

    return useLanguageFromLanguageSelect ? ttsSelectedLanguage : ttsSelectedVoice?.language;
};

export const useUpdateAgentById = () => {
    const agentEditorStore = useAgentEditorStore();
    const { mutateAsync: updateAgent } = useUpdateAgent();

    const formatUpdates = (updates: RawAgentUpdates): AgentUpdateDTO => {
        const formattedUpdates: AgentUpdateDTO = {};

        if (updates.llm) {
            formattedUpdates.llm = updates.llm;
        }

        if (updates?.presenter?.background && Object.keys(updates.presenter.background).length > 0) {
            formattedUpdates.presenter = {
                ...formattedUpdates.presenter,
                presenter_id: updates.presenter.id,
                type: updates.presenter.type as 'clip' | 'talk',
                background: updates.presenter.background,
                thumbnail: updates.presenter.thumbnail,
            };
        }

        if (agentEditorStore.currentTab === AgentCreateTabType.Details) {
            formattedUpdates.preview_name = updates?.agentName?.trim() ?? AGENT_DEFAULT_NAME;

            if (!updates?.presenter || !updates?.voice) {
                return formattedUpdates;
            }

            formattedUpdates.presenter = {
                ...formattedUpdates.presenter,
                voice: updates.voice,
            };
        }

        if (agentEditorStore.currentTab === AgentCreateTabType.ChatSettings) {
            formattedUpdates.greetings = updates.greetings;
            formattedUpdates.starter_message = updates.starterMessage;
            formattedUpdates.triggers = updates.triggers;
        }

        return formattedUpdates;
    };

    return async (payload: RawUpdatePayload) =>
        updateAgent({ knowledgeId: payload.updates.knowledgeId, agentId: payload.agentId, update: formatUpdates(payload.updates) });
};
